import { OptionalStateCarts, StateCart } from '../CartsState';
import { CartsCookie } from '../../../dataloaders/CartsCookie';
import { RootState } from '../../RootState';
import initializeCartsCookie from '../../../initializeCartsCookie';
import selectCarts from './selectCarts';

const selectCartsCookie = (state: RootState): CartsCookie => {
  const cartsCookie: CartsCookie = initializeCartsCookie();
  const stateCarts: OptionalStateCarts = selectCarts(state);

  Object.entries(stateCarts).forEach(([customOrderType, stateCart]: [string, StateCart | null]) => {
    if (stateCart !== null) {
      cartsCookie[customOrderType as keyof OptionalStateCarts] = {
        cartId: stateCart.code,
        userId: stateCart.user.id,
        userType: stateCart.user.type
      };
    }
  });

  return cartsCookie;
};

export default selectCartsCookie;
